import axios from "axios"
import { Community, UserLanguages, UserProfile } from "@models/user"
import { Role } from "src/UserService"
import { GatedCommunityProfileStatus } from "./gatedCommunities"

const ENDPOINT_PREFIX = "/api/wfl/"

export interface UpdateProfileRequest {
  name: string
  surname: string
  email: string
  timezone: string
}

export interface UserUsageSummary {
  aiTextCount: number
  aiFileCount: number
  llmAskCount: number
  llmCreateCount: number
  translationLimit: number | null // null means unlimited
}

export async function getUserDetails(): Promise<UserProfile> {
  const url = ENDPOINT_PREFIX + "my_exfluency/settings/profile"
  const resp = await axios.get(url)
  return resp.data
}
export async function getUserCommunities(username: string): Promise<Community[]> {
  const url = ENDPOINT_PREFIX + "groups_management/communities/my"
  const params = { isMember: false }
  const response = await axios.get(url, { params })
  const communities = Array.isArray(response.data) ? response.data : []
  return mapCommunityNames(username)(communities)
}

export const resolveKnowledgeBaseName = (communityName: string, userName: string): string =>
  communityName.toLowerCase() === userName.toLowerCase() + "'s knowledge base" ? "My Knowledge Base" : communityName

const mapCommunityNames = (username: string) => (communities: Community[]) =>
  communities.map((community) => ({
    ...community,
    gatedCommunityName: resolveKnowledgeBaseName(community.gatedCommunityName, username)
  }))

export const updateActivity = () => axios.post(ENDPOINT_PREFIX + "my_exfluency/activity")

export const getAvatar = (username: string, size: "SMALL" | "BIG") =>
  axios.get<any>(`/api/wfl/my_exfluency/settings/photo/${username}`, {
    params: { size: size },
    responseType: "blob"
  })

export const changePassword = (oldPassword: string, newPassword: string) =>
  axios.post("/api/wfl/auth/password/change", { newPassword, oldPassword })

export const updateProfile = (request: UpdateProfileRequest) => axios.put("/api/wfl/my_exfluency/settings", request)

export const getCurrentUserUsage = async (): Promise<UserUsageSummary> => {
  const response = await axios.get("/api/admin/users/current-user/usage")
  return response.data
}

export function updateUserRoles(userId: string, roles: Role[]) {
  return axios
    .put<void>(`/api/wfl/users/${userId}/roles`, { roles })
    .then((r) => r.data)
}

export function updateUserCommunities(
  userId: string,
  communities: { communityId: string; profile: GatedCommunityProfileStatus }[]
) {
  return axios
    .put<void>(`/api/wfl/users/${userId}/communities`, { communities })
    .then((r) => r.data)
}

export const updateUserLanguages = (languages: UserLanguages) => axios.put(`/api/snc/current-user/languages`, languages)

export const getUserLanguages = () => axios.get(`/api/snc/current-user/languages`)
